import DOMPurify, { Config as DOMPurifyConfig } from 'dompurify';

export function sanitizeHtml(html: string): string {
    return DOMPurify.sanitize(html, sanitizationConfig);
}

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
        node.setAttribute('rel', 'noopener noreferrer');
    }
});

/**
 * aims to allow significant styling via MD and some custom HTML tags,
 * without breaking surrounding styling or looking out of place
 */
export const sanitizationConfig: DOMPurifyConfig = {
    ALLOWED_TAGS: [
        'div',
        // -- headings
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        // -- block
        'p',
        'br',
        'hr',
        'blockquote',
        'pre',
        // -- lists
        'ul',
        'ol',
        'li',
        // -- inline text
        'code',
        'strong',
        'b',
        'em',
        'i',
        'del',
        's', // strikethrough (GFM)
        'mark', // ==highlight== (some flavors)
        'sup',
        'sub', // superscript/subscript
        'span', // used by some renderers for inline spans
        // -- links & media
        'a',
        'img',
        // -- tables (GFM)
        'table',
        'thead',
        'tbody',
        'tfoot',
        'tr',
        'th',
        'td',
        // -- misc
        'details',
        'summary', // collapsible sections (some flavors)
    ],
    ALLOWED_ATTR: [
        // -- links
        'href',
        'title',
        'rel',
        'target',
        // -- images
        'src',
        'alt',
        'title',
        'width',
        'height',
        // -- tables
        'align',
        'colspan',
        'rowspan',
        // -- ordered list start offset
        'start',
        // -- syntax highlighting (e.g. class="language-ts")
        'class',
    ],
};
